import {initMentorshipSessions} from "actions/mentorshipAction";
import {get} from "lodash";
import {connect} from 'react-redux';
import CurriculumMilestones from "views/Mentorship/CurriculumMilestones";

const mapStateToProps = ({mentorship: {sessions}, auth: {user}}) => ({
  sessions,
  selfPicture: get(user, 'picture'),
});

export default connect(mapStateToProps, {initMentorshipSessions})(CurriculumMilestones);
